import React from 'react';
import Sponsor from './Sponsor/Sponsor';
import {Row} from 'reactstrap';
import bufdir from '../../assets/images/sponsors/bufdir.jpg';
import sparebank from '../../assets/images/sponsors/sparebank.png';
import frifond from '../../assets/images/sponsors/frifond.png';
import monster from '../../assets/images/sponsors/monster.jpg';
import jorgensen from '../../assets/images/sponsors/jorgensen.png';
import gsport from '../../assets/images/sponsors/gsport.png';

const sponsors = () => {
    const items = [
        {
            id: 1,
            name: 'Barne-, Ungdoms- og Familiedirektoratet',
            logo: bufdir,
            url: 'https://bufdir.no'
        },
        {
            id: 2,
            name: 'Sparebank 1 Stiftelsen Halden',
            logo: sparebank,
            url: 'http://www.sparebank1stiftelsenhalden.no/'
        },
        {
            id: 3,
            name: 'Frifond Barn og Unge',
            logo: frifond,
            url: 'https://www.frifond.no/'
        },
        {
            id: 4,
            name: 'Monsternett',
            logo: monster,
            url: 'https://monsternett.no'
        },
        {
            id: 5,
            name: 'F. Jørgensen AS',
            logo: jorgensen,
            url: 'https://www.comfort.no/rorlegger/ostfold/comfort-halden/'
        },
        {
            id: 6,
            name: 'G-sport Svinesundparken',
            logo: gsport,
            url: 'https://www.gsport.no/butikker/g-sport-svinesundparken'
        }
    ];

    let content = items.map(sponsor => {
       return(
           <Sponsor url={sponsor.url} img={sponsor.logo} name={sponsor.name} key={sponsor.id}/>
       )
    });

    return(
      <Row>
          {content}
      </Row>
    )
};

export default sponsors;


// WEBPACK FOOTER //
// ./src/components/Sponsors/Sponsors.js